import React from 'react'

const url = window.location.href

const Schema = ({
    mainProduct,
    productTitle,
    productDescriptionText,
    sku,
    mainImage,
    currentPrice,
}) => {
    let now = new Date()
    let current = new Date(now.getFullYear(), now.getMonth() + 1, 1)

    // console.log('productDescription', productDescription)
    return (
        <div itemScope itemType="http://schema.org/Product">
            <meta
                itemProp="name"
                content={productTitle.split('_')[0].replace('[hidden]', '')}
            />
            <meta
                itemProp="description"
                content={
                    productDescriptionText
                        ? productDescriptionText
                        : ''
                }
            />
            <meta itemProp="sku" content={sku} />
            <meta itemProp="url" content={url} />
            <meta itemProp="image" content={mainImage.src} />
            <meta itemProp="brand" content={mainProduct[0].vendor} />
            <meta itemProp="mpn" content={sku} />
            <div itemProp="offers" itemScope itemType="http://schema.org/Offer">
                <meta itemProp="priceCurrency" content="USD" />
                <meta itemProp="price" content={currentPrice.price} />
                <meta itemProp="priceValidUntil" content={current} />
                <meta
                    itemProp="availability"
                    content="http://schema.org/InStock"
                />
                <meta
                    itemProp="itemCondition"
                    itemType="http://schema.org/OfferItemCondition"
                    content="http://schema.org/NewCondition"
                />
                <meta itemProp="seller" content="Monica + Andy" />
                <meta itemProp="url" content={url} />
            </div>
        </div>
    )
}

export default Schema
